import { FC, ReactNode } from 'react'

import styled from '@emotion/styled'

import { spacing } from '@cash-design-system/react'
import { AllocationDestination } from '@cash-web/protos/squareup/cash/paychecks/common.pb'

export const DISTRIBUTION_IDS: (keyof AllocationDestination)[] = ['cashBalance', 'investing', 'savings', 'bitcoin']

export type Arc = {
  label: string
  color: string
  arc: string
  linecap: 'round' | 'butt'
}

export type ArcWithAngles = {
  id: string
  label: string
  color: string
  startAngle: number
  endAngle: number
}

export type PieChartProps = {
  arcs: { arcs: ReactNode[]; masks: ReactNode[] }
  // The hero element is rendered in the center of the pie chart and must contain svg elements
  hero: ReactNode
}

const FullWidthSvg = styled.svg`
  padding: 0 ${spacing.xl};
  width: 100%;
`

export const PieChart: FC<PieChartProps> = ({ arcs, hero }) => {
  return (
    <FullWidthSvg viewBox="0 0 110 110" data-testid="pie-chart">
      {arcs.masks}
      {arcs.arcs}
      {hero}
    </FullWidthSvg>
  )
}

export default PieChart
